import {
  addRoleWithPermissions,
  getAllPermissions,
} from "../../../Redux/Users/UsersActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import arrowIcon from "../../../Assets/arrowleft.png";
import makeAnimated from "react-select/animated";
import { Link, useNavigate } from "react-router";
import validator from "../../../Util/validator";
import { useEffect, useState } from "react";
import styles from "./AddRole.module.scss";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Select from "react-select";

const animatedComponents = makeAnimated();

function AddRole() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { permissionsLoading, permissions, addRoleWithPermissionsLoading } =
    useSelector((state: RootState) => state.users);
  const [roleName, setRoleName] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const [errors, setErrors] = useState<{
    roleName: string;
    selectedPermissions: string;
  }>({
    roleName: "",
    selectedPermissions: "",
  });

  const options: any = permissions?.map((permission: any) => ({
    label: permission.permissionName,
    value: permission.permissionId.toString(),
    data: permission,
  }));

  const addRoleHandler = () => {
    const { isValid, errors: fieldErrors } = validator([
      {
        key: "roleName",
        value: roleName,
        type: "text",
      },
      {
        key: "selectedPermissions",
        value: selectedPermissions,
        type: "array",
      },
    ]);

    setErrors({ ...errors, ...fieldErrors });

    if (isValid && !addRoleWithPermissionsLoading) {
      const successHandler = () => {
        navigate("/admin/roles", { replace: true });
      };

      dispatch(
        addRoleWithPermissions({
          roleName,
          permissionIds: selectedPermissions?.map(
            (permission: any) => permission?.data?.permissionId,
          ),
          successHandler,
        }),
      );
    }
  };

  useEffect(() => {
    dispatch(getAllPermissions());
  }, [dispatch]);

  if (permissionsLoading) {
    return <Loading />;
  }
  return (
    <div className={styles.mainContainer}>
      <Link to="/admin/roles" replace className={styles.backButtonContainer}>
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Roles
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Add Role</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Role Name</p>
          <input
            type="text"
            className={styles.input}
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
          />
          <p className={styles.error}>{errors.roleName}</p>
        </div>

        <div className={styles.inputContainer}>
          <Select
            className={styles.select}
            closeMenuOnSelect={false}
            components={animatedComponents}
            value={selectedPermissions}
            isMulti
            options={options ?? []}
            onChange={(e: any) => {
              setSelectedPermissions(e);
            }}
          />
          <p className={styles.error}>{errors.selectedPermissions}</p>
        </div>

        {addRoleWithPermissionsLoading && <Loading />}

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={addRoleHandler}>
            Add Role
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddRole;
